// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2bmmp","tagContainer":"styles_tagContainer__3O2JG","edit":"styles_edit__2nNbb","buttons":"styles_buttons__1n7F_","infoSpan":"styles_infoSpan__O-A8E"};